webpackJsonp([272286920478453],{

/***/ 1517:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"ProductConfigInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"defaultNotes","type":{"kind":"SCALAR","name":"String","ofType":null}},{"defaultValue":null,"description":null,"name":"dosageConfig","type":{"kind":"INPUT_OBJECT","name":"DosageConfigInput","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-product-config-input-fadbfd5ffcf5112e80ba.js